module.exports = __webpack_public_path__ + "img/全天候技术支持.27663f44.svg";